<template>
  <div>
    <v-card>
      <v-card-title primary-title>
        <v-layout row wrap>
          
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs6>
              <v-img src="img/Top.jpg" aspect-ratio="1.7"></v-img>
            </v-flex>
            <v-flex xs6 class="card-item">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    name="tops"
                    label="Tops"
                    id="tops"
                    v-model="itemData.tops"
                    outline
                    @focus="$event.target.select()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                   <v-text-field
                    name="pieces"
                    label="Piezas por kilo"
                    id="pieces"
                    type="number" 
                    v-model="itemData.pieces_per_kilo"
                    @focus="$event.target.select()"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                   <v-text-field
                    name="tops_price"
                    label="Precio"
                    id="tops_price"
                    type="number"
                    v-model="itemData.tops_price"
                    @focus="$event.target.select()"
                    outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 text-xs-right>
              <v-btn color="success" @click="addItem">Agregar</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultItemData: {
        tops: 0,
        pieces_per_kilo: 0.00,
        tops_price: 0.00,
        type: 'TOP',
      },
      itemData: {
        tops: 0,
        pieces_per_kilo: 0.00,
        tops_price: 0.00,
        type: 'TOP',
      },
    };
  },
  computed: {
  },
  methods: {
    addItem() {
      if (this.isLineValid()) {
        this.itemData.tops = parseFloat(this.itemData.tops, 10);
        this.itemData.pieces_per_kilo = parseFloat(this.itemData.pieces_per_kilo);
        this.itemData.tops_price = parseFloat(this.itemData.tops_price);

        this.$emit('add-item', this.itemData);
        this.itemData = Object.assign({}, this.defaultItemData);
      } else {
        this.$emit('warning', 'Capture el numero de tops o las piezas por kilo');
      }
    },
    isLineValid() {
      return this.itemData.tops > 0 || this.itemData.pieces_per_kilo > 0;
    },
  },
};
</script>